import { useContext } from 'react';
import { Empty } from 'antd';

import { SessaoARContext } from '../../../Contexts/SessaoContext';
import { EnumTipoUsuario } from '../../../../Models/Domain/AreaRestrita/Sessao';
import { Viagem } from '../../../Components/Viagem';

export const MinhasViagens: React.FC<{}> = (props) => {

    const SessaoAR = useContext(SessaoARContext);

    const tipoDeUsuario = SessaoAR?.sessao?.tipoDeUsuario;

    if (tipoDeUsuario == EnumTipoUsuario.Responsavel) {
        return (
            <Viagem>
                <Viagem.ParaTipoResponsavel />
            </Viagem>
        )
    } else if (tipoDeUsuario == EnumTipoUsuario.Escola) {
        return (
            <Viagem>
                <Viagem.ParaTipoEscola />
            </Viagem>
        )
    }

    return <Empty />
}

